<template>
    <div class="www pt-2 pb-6 select-none">
        <div class="text-sm font-medium text-gray-700">
            {{ t('templateBlockDeletion') }}
        </div>
        <div class="pt-5">
            <ActionButton
                :value="t('templateBlockDelete')"
                state="danger"
                :icon="MdiDelete"
                :is-disabled="!stateRepository.states.blockDelete"
                @click="ask()"
            />
        </div>
    </div>

    <ModalPrompt
        :state="confirmModal.state"
        :buttons="confirmModal.buttons"
    />
</template>

<script setup>
    import { reactive } from 'vue';
    import ActionButton from '../ui/ActionButton.vue';
    import ModalPrompt from '../ui/ModalPrompt.vue';
    import { t } from '../composables/i18n';
    import { MdiDelete, MdiChevronLeft } from 'materialdesignicons-vue3/icons/';
    import { deleteRow, findRowIndexById } from '../composables/useTemplateModel';

    defineExpose({
        name: 'BlockDeleteWidget',
    });

    const props = defineProps({
        templateModel: {
            type: Object,
            required: true,
        },
        rowId: {
            type: String,
            required: true,
        },
        stateRepository: {
            type: Object,
            required: true,
        },
    });

    const templateModel = props.templateModel;
    const rowId = props.rowId;
    const stateRepository = props.stateRepository;

    const confirmModal = reactive({
        state: {
            open: false,
            title: t('templateBlockDelete'),
            text: t('templateBlockDeleteAsk', {
                id: rowId,
            }),
            data: {},
            overlayPreventClose: false,
        },
        buttons: [
            {
                title: t('buttonClose'),
                action: () => {
                    confirmModal.state.open = false;
                },
                icon: MdiChevronLeft,
                state: 'neutral',
            },
            {
                title: t('buttonYes'),
                action: () => {
                    deleteRow(templateModel, findRowIndexById(templateModel, rowId));
                    confirmModal.state.open = false;
                },
                state: 'danger',
                icon: MdiDelete,
            },
        ],
    });

    const ask = () => {
        confirmModal.state.open = true;
    };
</script>
